import React,{useState,}from 'react'
import { Modal,message,Form,Input,Button, Radio} from 'antd';
import GetUserDept from '../../cpn/GetUserDept';
import { useFinanceSubTypeAddMutation } from '../../store/BnsKeJiApi';
function BalanceTypeAdd() {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateClient = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState();
    const [submitAdd] = useFinanceSubTypeAddMutation()
    return (
        <>
            <Button type='primary' onClick={() => {setOpen(true)}}>新增</Button>
            <Modal
                open={open}
                title={`新增收支类型`}
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateClient(values);
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                        });                            
                    submitAdd({
                        efst_e_id:localStorage.getItem('e_id'),
                        efst_finance_type_id:info.efst_finance_type_id,
                        efst_name:info.efst_name,                               
                        efst_uid:localStorage.getItem('eu_id'),
                        efst_uname:localStorage.getItem('eu_name'),
                        efst_content:'',
                        efst_dept_id:info.efst_dept_id,
                    }).then((res) => {
                        console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('新增成功！') 
                            setOpen(false)                         
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 7 }}
                >                            
                    <Form.Item
                        label='科目'
                        required
                        name='type'
                    >
                        <Radio.Group
                            onChange={(e) => {
                                setInfo(prevState=>({
                                    ...prevState,
                                    efst_finance_type_id:e.target.value
                                }))
                            }}
                        >
                            <Radio value='1'>销售收入</Radio>
                            <Radio value='2'>成本支出</Radio>
                            <Radio value='3'>费用支出</Radio>
                            <Radio value='4'>其他收入</Radio>
                            <Radio value='5'>其他支出</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <GetUserDept label='部门' name='dept' getUserDept={(e) => {setInfo(prevState=>({...prevState,efst_dept_id:e}))}} required/>
                    <Form.Item name="name" label='类型' wrapperCol={{span:10}} required>
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,efst_name:e.target.value}))}}/>
                    </Form.Item>                    
                </Form>
            </Modal>                    
        </>
    )
}

export default BalanceTypeAdd